<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-6">
      <h1 class="text-center">Panel de Configuración</h1>
      <div class="order-status-wrapper">
        <h1>Estatus de pedidos</h1>
        <router-link class="btn ver-todos-btn" :to="{name: 'todasOrdenesStatus'}"> Ver todo </router-link>
      </div>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col xl="3" md="6">
          <stats-card :title="orders_new.length.toString()"
                      sub-title="Solicitudes nuevas"
                      icon="img/theme/icn_estatus1.svg"
                      class="mb-4">
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card :title="orders_transit.length.toString()"
                      sub-title="En tránsito"
                      icon="img/theme/icn_estatus2.svg"
                      class="mb-4">
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card :title="orders_delivered.length.toString()"
                      sub-title="Ordenes entregadas"
                      icon="img/theme/icn_estatus3.svg"
                      class="mb-4">
          </stats-card>

        </b-col>
        <b-col xl="3" md="6">
          <stats-card :title="orders_pendientes.length.toString()"
                      sub-title="Pendientes de entrega"
                      icon="img/theme/icn_estatus4.svg"
                      class="mb-4">
          </stats-card>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid class="">
      <b-row>
        <b-col md="6">
          <b-card no-body>
            <b-card-header class="border-0">
              <span class="title-table-status">Ordenes en proceso</span>
            </b-card-header>
            <el-table class="table-responsive table"
                      header-row-class-name="thead-light"
                      @row-click="showModalOrder"
                      :data="pagedTableDataProcess">
                <el-table-column label="No. Orden"
                                  width="100px"
                                  prop="name">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                                {{row.id}}
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="Nombre"
                          prop="name">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            {{row.name}} {{row.first_lastname}} {{row.second_lastname}}
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="Hospital"
                                  prop="name">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            {{row.hospital}}
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="Fecha"
                                  prop="name">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            {{row.date}}
                        </b-media>
                    </template>
                </el-table-column>
            </el-table>
          </b-card>
        </b-col>
        <b-col md="6">
          <b-card no-body>
            <b-card-header class="border-0">
              <span class="title-table-status">Entregas parciales</span>
            </b-card-header>
            <el-table class="table-responsive table"
                      header-row-class-name="thead-light"
                      @row-click="showModalOrder"
                      :data="pagedTableData">
                <el-table-column label="No. Orden"
                                  width="100px"
                                  prop="name">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                          {{row.id}}
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="Nombre"
                                  prop="name">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            {{row.name}} {{row.first_lastname}} {{row.second_lastname}}
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="Hospital"
                          prop="name">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            {{row.hospital}}
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="Fecha"
                          prop="name">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            {{row.date}}
                        </b-media>
                    </template>
                </el-table-column>
            </el-table>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
  import axios from 'axios'
  import qs from 'qs'
  import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';

  export default {
    data() {
      return {
        orders_new: [],
        orders_transit: [],
        orders_delivered: [],
        orders_pendientes: [],
        token:'',
        user:'',
        currentPage: 1,
        pageSize: 10,
        search: ''
      };
    },
    components: {
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn

    },
    created () {
      this.token = localStorage.getItem('token')
      this.user = localStorage.getItem('id_user')
      axios
      .post(
        process.env.VUE_APP_ROUTE_BACKEND_API+'orders_api.php',
        qs.stringify({ api_token: this.token, user_id: this.user, option: 'get_orders'}),
      )
      .then((response) => {
        if (!response.data.error.code && response.data.orders) {
          let temp_new = [],
              temp_transit = [],
              temp_delivered = [],
              temp_cancel = []

          Object.keys(response.data.orders_solicitud).map((key) => [response.data.orders_solicitud[key]]).map(function(value) {
              temp_new.push(value[0])
          })

          Object.keys(response.data.orders_transito).map((key) => [response.data.orders_transito[key]]).map(function(value) {
              temp_transit.push(value[0])
          })

          Object.keys(response.data.orders_entregado).map((key) => [response.data.orders_entregado[key]]).map(function(value) {
              temp_delivered.push(value[0])
          })

          Object.keys(response.data.orders_pendiente).map((key) => [response.data.orders_pendiente[key]]).map(function(value) {
              temp_cancel.push(value[0])
          })

          this.orders_new = temp_new
          this.orders_transit = temp_transit
          this.orders_delivered = temp_delivered
          this.orders_pendientes = temp_cancel
        }
      })
      .catch((err) => {
        console.log(err)
      })
    },
    computed: {
      pagedTableDataProcess() {
        return this.orders_new.slice(this.pageSize * this.currentPage - this.pageSize, this.pageSize * this.currentPage)
      },
      pagedTableData() {
        return this.orders_delivered.slice(this.pageSize * this.currentPage - this.pageSize, this.pageSize * this.currentPage)
      }
    },
    methods : {
      setPage (val) {
        this.currentPage = val
      },
      showModalOrder (index) {
        console.log(index)
      }
    }
  };
</script>
<style>
.el-table, a{
  color: #112357;
}
.ver-todos-btn{
  color: #fff !important;
  font-weight: normal;
  border: 1px solid #fff;
  border-radius: 0;
  margin-left: auto;
}
.order-status-wrapper{
  display: flex;
}
.title-table-status{
  color: #112357;
  font-weight: bold;
  font-size: 15px;
}

@media (max-width: 1600px) {
  .title-table-status{
    font-size: 13px;
  }
}
</style>
